export const storeName   = "WPTravel/TourGuide";
export const elementId   = "wp-travel-travel-guide";
export const apiEndPoint = "/wp-travel/v1/travel-guide";
export const apiTripEndPoint = "/wp-travel/v1/trip";
export const clsprefix   = "wp-travel-travel-guide";
// export const nonce       = WTTG.nonce;
